import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

interface UseIsAccommodationsAiRecommendationsEnabledReturn
  extends Readonly<{
    isAccommodationsAiRecommendationsEnabled: boolean;
    isLoading: boolean;
  }> {}

/**
 * Hook to check if AI recommendations for accommodations are enabled.
 * Depends on asyncHotelAutopopulationEnabled being enabled first.
 */
export const useIsAccommodationsAiRecommendationsEnabled = (): UseIsAccommodationsAiRecommendationsEnabledReturn => {
  const [asyncHotelAutopopulationEnabled, loadingAsyncHotelAutopopulationEnabled] = useIsFeatureEnabled('asyncHotelAutopopulationEnabled');

  const [isAccommodationsAiRecommendationsEnabled, loadingIsAccommodationsAiRecommendationsEnabled] = useIsFeatureEnabled('accommodationsAiRecommendations', {
    skip: !asyncHotelAutopopulationEnabled,
  });

  return useMemo(
    () => ({
      isAccommodationsAiRecommendationsEnabled,
      isLoading: loadingAsyncHotelAutopopulationEnabled || loadingIsAccommodationsAiRecommendationsEnabled,
    }),
    [isAccommodationsAiRecommendationsEnabled, loadingAsyncHotelAutopopulationEnabled, loadingIsAccommodationsAiRecommendationsEnabled],
  );
};
